<template>
  <div>
    <div class="product-window" :class="attr.cartAttr === true ? 'on' : ''">
      <div class="textpic acea-row row-between-wrapper">
        <div class="pictrue">
          <img :src="attr.productSelect.image" class="image" />
        </div>
        <div class="text">
          <div class="line1">
            {{ attr.productSelect.store_name }}
          </div>
          <div
            class="money font-color-red"
            v-if="couponsList[0] && couponsList[0].coupon_type == 2"
          >
            <div class="wrapper"></div>
            <span class="stock"></span>
          </div>
          <div class="money font-color-red" v-else>
            <span class="num">{{ attr.productSelect.price }}</span>
            <span class="stock">库存: {{ attr.productSelect.stock }}</span>
          </div>
        </div>
        <div class="iconfont icon-guanbi" @click="closeAttr"></div>
      </div>
      <!-- 多规格 -->
      <div class="productWinList">
        <div
          class="item"
          v-for="(item, indexw) in attr.productAttr"
          :key="indexw"
        >
          <div
            class="title"
            v-if="item.productAttr && item.productAttr.length > 0"
          >
            {{ item.product.store_name }}
          </div>
          <div class="listn acea-row row-middle">
            <div
              class="itemn"
              :class="
                itemn[0] === (attr.selectList && attr.selectList[indexw] && attr.selectList[indexw].attr)
                  ? 'on'
                  : ''
              "
              v-for="(itemn, indexn) in Object.entries(item.productValue)"
              @click="tapAttr(itemn, indexn)"
              :key="indexn"
            >
              {{ itemn[0] }}
            </div>
          </div>
        </div>
      </div>
      <div class="cart">
        <div class="title">数量</div>
        <div class="carnum acea-row row-left">
          <div
            class="item reduce"
            :class="attr.productSelect.cart_num <= 1 ? 'on' : ''"
            @click="CartNumDes"
          >
            -
          </div>
          <div class="item num">{{ attr.productSelect.cart_num }}</div>
          <div
            class="item plus"
            :class="
              attr.productSelect.cart_num >= attr.productSelect.stock
                ? 'on'
                : ''
            "
            @click="CartNumAdd"
          >
            +
          </div>
        </div>
      </div>
    </div>
    <div
      class="mask"
      @touchmove.prevent
      :hidden="attr.cartAttr === false"
      @click="closeAttr"
    ></div>
  </div>
</template>
<script>
export default {
  name: "MultipleSpecifications",
  props: {
    attr: {
      type: Object,
      default: () => {},
    },
    couponsList: {
      type: Array,
      default: () => [],
    },
  },
  data: function () {
    return {};
  },
  mounted: function () {},
  methods: {
    closeAttr: function () {
      this.$emit("changeFun", { action: "ischangemultiple", value: false });
    },
    CartNumDes: function () {
      this.$emit("changeFun", { action: "changeMultCartNum", value: false });
    },
    CartNumAdd: function () {
      this.$emit("changeFun", { action: "changeMultCartNum", value: 1 });
    },
    tapAttr: function (indexw) {
      // console.log(indexw, "indexw");
      let checkItem = indexw[1];
      let value = {
        id: checkItem.product_id,
        val: indexw[0],
        que: checkItem.unique
      };
      this.$emit("changeFun", { action: "ChangeMultiple", value: value });
    },
  },
};
</script>
